import React, { useContext, useState, useEffect, useMemo, useRef } from 'react'
import {
  strCol,
  intCol,
  dateTimeCol,
  numCol,
} from '@integec/grid-tools/lib/cols'
import {
  modifierCol,
  modifiedDateCol,
  utilityReqHeader,
  unitHeader,
} from 'core/HeaderColTypeProps'
import { getApiTargetInfo, UnitSelection, ExportComponent } from 'core'
import { connect } from 'react-redux'
import R from 'ramda'
import {
  // getCard97,
  // deleteCard97,
  getSystemConfigurationInfo,
  // getUnitInfo,
  // getAmpCodeMgmtInfo,
  // getFailCodeMgmtInfo,
  // getCard97Idx,
  dukefossilCard97,
  // getCard97ExtensionSpec,
} from 'api/pgads'

import {
  getUtilityNameMap,
  getUnitNameMap,
  getUtilityUnitsMap,
  getCauseCodeMap,
  getUnits,
  getFailCode,
  getAmlificationCode,
  getPermitActions,
  getEnvConfig,
  getEventTypes,
  getCauseCodeOmcMap,
} from 'core/selectors'
import { Button, Input, Empty, message, Select } from 'antd'
import {
  UnitSelectionContext,
  SpinContext,
  ErrorContext,
  DatePickerContext,
} from 'context'
import { CriteriaRow, Title, Content, FullHeightSizer } from 'core/screen-util'
import Grid, {
  virtualizedGridRenderer,
  defaultVirtualizedCellRender,
  VirtualizedCell,
  extractAndFormatData,
} from '@integec/grid-tools'
import {
  rowHeaderRender,
  // hasAccesPermits,
  exportDataComponent,
} from 'core/utils'

import moment from 'moment'
// import * as ScreenPermissions from 'core/EventActions'

const DukeFosCard97Reference = ({
  utilityNameMap,
  unitNameMap,
  // utilityUnitMap,
  // causeCodeMap,
  apiTargetInfo,
  // actionPermits,
  // envConfig,
  eventTypesData,
  units,
  causeCodeOmcMap,
}) => {
  const title = 'Duke Card 97'
  const GridRef = useRef()
  const [fuzzyFilter, setFuzzyFilter] = useState('')
  // const CLIENT = envConfig.clientId || 'INTEG'
  const { setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const [data, setData] = useState(null)
  const { selectedUnits, setVisibleUnitSelection } = useContext(
    UnitSelectionContext
  )
  // const [unitCodeMap, setUnitCodeMap] = useState({})
  const { setSelectedDate } = useContext(DatePickerContext)
  const [selEventTypes, setSelEventTypes] = useState(['ALL'])
  const [card97Dominant, setCard97Dominant] = useState(false)

  const curYear = new Date().getFullYear()
  const [year, setYear] = useState(curYear)
  const yearOption = R.range(curYear - 18, curYear + 4)
    .sort((a, b) => b - a)
    .map(i => (
      <Select.Option value={i} key={i}>
        {i}
      </Select.Option>
    ))

  const eventTypes = useMemo(_ => eventTypesData.map(e => e.eventType), [
    eventTypesData,
  ])

  useEffect(
    _ => {
      getSystemConfigurationInfo(apiTargetInfo).fork(setError, d => {
        const dominantData = d.filter(
          s => s.key === 'DOMINANT_DERATE' && s.value === 'YES'
        )
        // setState({ card97Dominant: dominantData.length > 0 ? true : false, loading: false })
        setCard97Dominant(dominantData.length > 0)
      })
      // setUnitCodeMap(unitCodeList(units))
    },
    [apiTargetInfo, setError, units]
  )
  const onRetrieveData = ({ selUnits = selectedUnits }) => {
    if (selUnits.length <= 0) {
      setVisibleUnitSelection(true)
      message.error('Please,Select Unit')
      return
    }
    if (selEventTypes.length <= 0) {
      message.error('Please,Select Event Types')
      return
    }
    setSpinning(true)
    dukefossilCard97(apiTargetInfo)(
      year || curYear,
      selUnits[0].utility,
      selUnits.map(u => u.unitId),
      selEventTypes.includes('ALL') ? eventTypes : selEventTypes
    ).fork(setError, data => {
      setSpinning(false)
      setData(data)
      // setSelectedRows([])

      //       if (GridRef.current) GridRef.current.setSelectedRect({})
    })
  }

  const clientHeaders = headers
  const filterHeaders = useMemo(
    _ =>
      card97Dominant
        ? clientHeaders
        : clientHeaders.filter(h => !(h.ident === 'ioCode')),
    [card97Dominant, clientHeaders]
  )

  const headerWithFormatter = useMemo(
    _ =>
      filterHeaders.map(header =>
        header.ident === 'utility'
          ? {
              ...header,
              // ...toSelectionColProps(utilityNameMap),
              dataFormatter: ({ value }) => utilityNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                utilityNameMap[rowData.utility] || rowData.utility,
            }
          : header.ident === 'unit'
          ? {
              ...header,
              // choices: [],
              dataFormatter: ({ value }) => unitNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                unitNameMap[rowData.unit] || rowData.unit,
            }
          : header
      ),
    [filterHeaders, unitNameMap, utilityNameMap]
  )
  const customizedCellRender = params => {
    const { gridToolProps, reactVirtualizedProps } = params

    const { getCellProps, headers, data } = gridToolProps

    const { columnIndex, rowIndex, style } = reactVirtualizedProps
    // const cellProps = getCellProps({
    //   rowIndex,
    //   columnIndex,
    //   header: headers[columnIndex],
    //   data,
    //   style,
    //   ...rest,
    // })

    const cellData = extractAndFormatData({
      rowData: data[rowIndex],
      header: headers[columnIndex],
    })

    if (headers[columnIndex].ident === 'causeCode') {
      const isOmc = causeCodeOmcMap[cellData]

      let omcCellProps = getCellProps({
        rowIndex,
        columnIndex,
        header: headers[columnIndex],
        data,
        style,
      })

      omcCellProps = {
        ...omcCellProps,
        style: {
          ...style,
          backgroundColor: isOmc
            ? 'rgb(255,128,64,0.5)'
            : cellData >= 9180 && cellData <= 9199
            ? 'rgb(194,57,237,0.5)'
            : undefined,
          color:
            omcCellProps.isSelected && isOmc
              ? 'black'
              : cellData >= 9180 && cellData <= 9199
              ? 'black'
              : undefined,
        },
      }

      return (
        <VirtualizedCell {...R.omit(['data'], omcCellProps)}>
          {cellData}
        </VirtualizedCell>
      )
    }

    return defaultVirtualizedCellRender({
      ...params,
    })
  }

  return (
    <div>
      <UnitSelection
        setData={() => {
          setData(null)
        }}
        accesskey="u"
        // retrieveData={onRetrieveData}
        // renderContent={renderUnitContent}
        retrieveData={onRetrieveData}
      />
      <CriteriaRow style={{}}>
        <Title
          style={{
            marginRight: '15px',
            marginBottom: '5px',
            marginLeft: '10px',
            minWidth: '200px',
          }}
        >
          {title}
        </Title>
        <div
          style={{
            display: 'grid',
            gridGap: '10px',
            width: '100%',
            gridTemplateColumns: '1fr',
          }}
        >
          <div
            style={{
              display: 'grid',
              justifyContent: 'end',
              alignContent: 'center',
              gridTemplateColumns: '100px 100px 200px 1fr 200px 200px',
              gap: '5px',
            }}
          >
            <div
              style={{
                display: 'grid',
                justifyContent: 'end',
                alignContent: 'center',
              }}
            >
              Year :
            </div>
            <Select
              style={{ minWidth: '90px' }}
              value={year}
              onChange={year => {
                setYear(year)
                setData([])
                setSelectedDate(moment(year + '1231'))
              }}
            >
              {yearOption}
            </Select>

            {/* <Button onClick={e => setCauseCodeDialog(true)}>Cause Code</Button> */}

            <Button
              style={{}}
              onClick={onRetrieveData}
              type="primary"
              icon="database"
            >
              Retrieve
            </Button>
            <div />
            <Input.Search
              placeholder="Filter"
              value={fuzzyFilter}
              style={{
                gridColumnEnd: 'span 1',
              }}
              onChange={e => setFuzzyFilter(e.target.value)}
            />
            <ExportComponent
              getData={_ => exportDataComponent(GridRef, data, fuzzyFilter)}
              data={data}
              headers={headerWithFormatter}
              fileName={title}
              btnStyle={{}}
              disabled={!!(data && data.length <= 0)}
            />
          </div>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '100px 1fr',
              gap: '5px',
            }}
          >
            <div
              style={{
                display: 'grid',
                justifyContent: 'end',
                alignContent: 'center',
              }}
            >
              Event Type :
            </div>
            <Select
              onChange={vals => {
                setSelEventTypes(vals)
                setData([])
              }}
              value={selEventTypes}
              placeholder="Select Event Types"
              mode="multiple"
            >
              <Select.Option value="ALL">ALL</Select.Option>
              {eventTypes.map(k => (
                <Select.Option key={k} value={k}>
                  {k}
                </Select.Option>
              ))}
            </Select>
          </div>
        </div>
      </CriteriaRow>
      <FullHeightSizer heightOffset={300}>
        {({ height, width }) =>
          data && data.length > 0 ? (
            <Content style={{ height: height - 20 }}>
              <Grid
                ref={GridRef}
                sortEnabled
                data={data}
                headers={headerWithFormatter}
                altBy={u => u.unit}
                altBgColor="#ebebeb"
                // onEditInfoChange={info => editRow(info)}
                // editInfo={editInfo}
                render={virtualizedGridRenderer({
                  autoFixColByKey: true,
                  rowHeaderRender,
                  height: height - 60,
                  width: width - 50,
                  cellRender: customizedCellRender,
                })}
                fuzzyFilter={fuzzyFilter}
                isEditable={false}
                selectionMode="single"
                selectionType="row"
                initialSortOptions={[
                  utilityReqHeader,
                  unitHeader,
                  { ident: 'year', sortOrder: 'asc' },
                  { ident: 'eventStart', sortOrder: 'asc' },
                  { ident: 'eventEnd', sortOrder: 'asc' },
                  // { ident: 'year', sortOrder: 'asc' },
                  { ident: 'eventNum', sortOrder: 'asc' },
                  // { ident: 'eventIdx', sortOrder: 'asc' },
                ]}
              />
            </Content>
          ) : (
            <Content style={{ height: '200px' }}>
              <Empty
                imageStyle={{ paddingTop: '30px' }}
                description={
                  selectedUnits && selectedUnits.length <= 0
                    ? 'Please select units'
                    : data && data.length <= 0
                    ? 'No Data from Retrieve'
                    : 'Please click on retrieve button to retrieve data'
                }
              />
            </Content>
          )
        }
      </FullHeightSizer>
    </div>
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  utilityUnitMap: getUtilityUnitsMap(state),
  causeCodeMap: getCauseCodeMap(state),
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
  units: getUnits(state),
  ampCodeMap: getAmlificationCode(state),
  failCodeMap: getFailCode(state),
  eventTypesData: getEventTypes(state),
  causeCodeOmcMap: getCauseCodeOmcMap(state),
})
export default connect(mapStateToProps)(DukeFosCard97Reference)

export const headers = [
  unitHeader,
  intCol({ ident: 'year', display: 'Year', isKey: true, width: 50 }),
  intCol({
    ident: 'eventNum',
    display: 'Event Number',
    isKey: true,
    width: 60,
  }),
  intCol({ ident: 'eventIdx', display: 'Event Index', isKey: true, width: 60 }),
  strCol({
    ident: 'eventType',
    display: 'Event Type',
    isKey: true,
    isFiltered: true,
    width: 60,
  }),
  utilityReqHeader,
  dateTimeCol({
    ident: 'eventStart',
    display: 'Event Start Date',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  dateTimeCol({
    ident: 'eventEnd',
    display: 'Event End Date',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),

  numCol({
    ident: 'eqHours',
    display: 'Equivalent Hours',
    // isKey: true,
    isFiltered: true,
  }),
  numCol({
    ident: 'eqMwh',
    display: 'Equivalent Lost MWh',
    // isKey: true,
    isFiltered: true,
  }),
  strCol({ ident: 'availCap', display: 'Available Capacity' }),
  numCol({
    ident: 'reduction',
    display: 'Reduction',
    // isKey: true,
    isFiltered: true,
  }),
  intCol({ ident: 'causeCode', display: 'Cause Code', isFiltered: true }),
  strCol({ ident: 'conCode', display: 'Contribution Code' }),
  strCol({ ident: 'ioCode', display: 'Dominant' }),
  dateTimeCol({
    ident: 'workStart',
    display: 'Work Start Date',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  dateTimeCol({
    ident: 'workEnd',
    display: 'Work End Date',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  intCol({ ident: 'manHour', display: 'Man Hours' }),
  strCol({ ident: 'failCode', display: 'Fail Code', isFiltered: true }),
  strCol({ ident: 'ampCode', display: 'Amplification Code', isFiltered: true }),
  strCol({
    ident: 'description',
    display: 'Description',
    width: 2000,
    alignment: 'left',
  }),

  modifierCol,
  modifiedDateCol,
  // strCol({ ident: 'lock', display: 'Lock' }),
].map(e => ({ ...e, isFiltered: true }))

// const unitCodeList = R.compose(
//   R.fromPairs,
//   R.map(a => [`${a.utility}${a.unit}`, a.id1])
// )
